import React, { useState, useEffect } from 'react'
import { Table, TableBody, TableCell, TableRow, Paper, Typography } from '@mui/material'
import LinearProgress from '@mui/material/LinearProgress'
import { LEGEND_COLOR_MAP_NEW } from '../../../../../constants'
import {
  Wrapper,
  ProgressBarWrapper,
  StyledTableContainer,
  StyledTableHead,
  NoDataFound,
} from './style'

// Reusable Progress Bar Component
const ProgressBar = ({ value, color }) => (
  <ProgressBarWrapper>
    <LinearProgress
      variant='determinate'
      value={value}
      sx={{
        width: '70%',
        mr: 1,
        height: 6,
        bgcolor: '#ddd',
        '& .MuiLinearProgress-bar': { bgcolor: color },
      }}
    />
    <Typography variant='body2'>{value}%</Typography>
  </ProgressBarWrapper>
)

const SentimentTable = ({ data, selectedObject, insightsElementType }) => {
  const [tableData, setTableData] = useState([])
  const [heading, setHeading] = useState('')

  const setHeadingFunc = () => {
    const monthArray = [
      'january',
      'february',
      'march',
      'april',
      'may',
      'june',
      'july',
      'august',
      'september',
      'october',
      'november',
      'december',
    ]
    const shortMonthArray = [
      'jan',
      'feb',
      'mar',
      'apr',
      'may',
      'jun',
      'jul',
      'aug',
      'sep',
      'oct',
      'nov',
      'dec',
    ]
    const shortMonthArray2 = [
      'dec-jan',
      'jan-feb',
      'feb-mar',
      'mar-apr',
      'apr-may',
      'may-jun',
      'jun-jul',
      'jul-aug',
      'aug-sep',
      'sep-oct',
      'oct-nov',
      'nov-dec',
    ]
    const periodH = ['h1', 'h2']
    const periodQ = ['q1', 'q2', 'q3', 'q4', 'h1', 'h2']
    const label = data[0].label.toLowerCase().split(' ')[0]
    console.log('label==============', label)
    if ([...monthArray, ...shortMonthArray, ...shortMonthArray2].includes(label)) {
      setHeading('Month')
    } else if (['phase'].includes(label)) {
      setHeading('Phase')
    } else if (periodQ.includes(label)) {
      setHeading('Quarter')
    } else if (periodH.includes(label)) {
      setHeading('Half')
    }
  }

  useEffect(() => {
    if (data?.length > 0) {
      const year = new Date().getFullYear()
      let finalData = data.map((d) => ({
        label: d.label,
        positive: d.otherDetails.PositivePercent,
        neutral: d.otherDetails.NeutralPercent,
        mixed: d.otherDetails.MixedPercent,
        negative: d.otherDetails.NegativePercent,
        total: d.otherDetails.Percent,
        searchKeywords: d.otherDetails.Percent,
        withoutSentiments: d.otherDetails.Percent,
        createdDate: d.otherDetails.CreatedDate,
      }))
      if (selectedObject?.progressionRangeObject?.barsInGraph) {
        finalData = finalData
          .slice(0, selectedObject.progressionRangeObject.barsInGraph)
          .filter((f) =>
            selectedObject.progressionRangeObject.barsInGraph === 15
              ? f?.createdDate?.match(year)?.length
              : f
          )
          .filter((f) => f.total > 0)
      }
      setTableData(finalData)
      setHeadingFunc()
    }
  }, [data, selectedObject])

  return (
    <>
      {!selectedObject?.showGraph && data?.length > 0 && (
        <Wrapper>
          <StyledTableContainer component={Paper}>
            <Table>
              <StyledTableHead>
                <TableRow>
                  <TableCell>{heading}</TableCell>
                  {insightsElementType === 'DriversProgression3Level' && (
                    <TableCell>Positive</TableCell>
                  )}
                  {insightsElementType === 'DriversProgression3Level' && (
                    <TableCell>Neutral</TableCell>
                  )}
                  {insightsElementType === 'DriversProgression3Level' && (
                    <TableCell>Mixed</TableCell>
                  )}
                  {insightsElementType === 'DriversProgression3Level' && (
                    <TableCell>Negative</TableCell>
                  )}
                  <TableCell>Total</TableCell>
                </TableRow>
              </StyledTableHead>
              <TableBody>
                {tableData?.length > 0 ? (
                  tableData.map((row, index) => (
                    <TableRow key={index}>
                      <TableCell>{row.label}</TableCell>
                      {insightsElementType === 'DriversProgression3Level' && (
                        <TableCell>
                          <ProgressBar value={row.positive} color={LEGEND_COLOR_MAP_NEW.Positive} />
                        </TableCell>
                      )}
                      {insightsElementType === 'DriversProgression3Level' && (
                        <TableCell>
                          <ProgressBar value={row.neutral} color={LEGEND_COLOR_MAP_NEW.Neutral} />
                        </TableCell>
                      )}
                      {insightsElementType === 'DriversProgression3Level' && (
                        <TableCell>
                          <ProgressBar value={row.mixed} color={LEGEND_COLOR_MAP_NEW.Mixed} />
                        </TableCell>
                      )}
                      {insightsElementType === 'DriversProgression3Level' && (
                        <TableCell>
                          <ProgressBar value={row.negative} color={LEGEND_COLOR_MAP_NEW.Negative} />
                        </TableCell>
                      )}
                      <TableCell>
                        <ProgressBar value={row.total} color={LEGEND_COLOR_MAP_NEW.Total} />
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell>
                      <NoDataFound>
                        <b>No Data</b>
                        <p>Switch to a broader range to explore available insights</p>
                      </NoDataFound>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </StyledTableContainer>
        </Wrapper>
      )}
    </>
  )
}

export default SentimentTable
